/* REVIEW-104: explain an unavailable launcher without changing consent or loading Swym. */
(function () {
  'use strict';
  var dialog = document.getElementById('bw-wishlist-availability');
  if (!dialog) return;
  var trigger;
  var message = dialog.querySelector('#bw-wishlist-message');
  var error = dialog.querySelector('[data-bw-cookie-error]');
  var settings = dialog.querySelector('[data-bw-cookie-settings]');

  function preferencesAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.preferencesProcessingAllowed === 'function') {
        return privacy.preferencesProcessingAllowed();
      }
    } catch (_) { /* Unknown is not an affirmative consent signal. */ }
    return null;
  }
  function show(denied) {
    var korean = /^ko\b/i.test(document.documentElement.lang);
    message.textContent = denied
      ? (korean
        ? '현재 개인화 쿠키가 꺼져 있어 위시리스트를 불러올 수 없습니다. 쿠키 설정에서 개인화를 켠 뒤 내 선택 사항 저장을 선택해 주세요. 현재 설정을 유지하고 쇼핑을 계속할 수도 있습니다.'
        : 'Personalization cookies are currently off, so your wishlist cannot load. To use your wishlist, open Cookie settings, enable Personalization, and select Save my choices. You can also keep your current settings and continue shopping.')
      : 'Wishlist is not ready yet. Please close this message and try again shortly. If it remains unavailable, review your cookie settings or reload the page.';
    error.hidden = true;
    if (!dialog.open) dialog.showModal();
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href="#swym-wishlist"]');
    if (!link) return;
    var allowed = preferencesAllowed();
    // If ready, leave Swym's original launcher and saved lists entirely untouched.
    if (allowed !== false && window._swat && window._swat.ui) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = link;
    show(allowed === false);
  }, true);
  dialog.querySelector('[data-bw-wishlist-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('close', function () { if (trigger && trigger.isConnected) trigger.focus(); });
  settings.addEventListener('click', function () {
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') { error.hidden = false; return; }
    settings.disabled = true;
    // Shopify owns the preferences UI; never grant any category on the visitor's behalf.
    try {
      dialog.close();
      Promise.resolve(banner.showPreferences()).then(function () {
        settings.disabled = false;
      }, function () { settings.disabled = false; show(preferencesAllowed() === false); error.hidden = false; });
    } catch (_) { settings.disabled = false; show(preferencesAllowed() === false); error.hidden = false; }
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (dialog.open && preferencesAllowed() === true) dialog.close();
  });
})();
